import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export type DateType = string | number | Date | dayjs.Dayjs | undefined;

export const DATE_ISO_FORMAT = 'YYYY-MM-DD';
export const DATE_US_LOCALE_FORMAT = 'MM/DD/YYYY';
export const DATE_WITH_TIME_US_LOCALE_FORMAT = 'MM/DD/YYYY - h:mm a';
export const DATE_START_TIME = 'T00:00:00Z';
export const DATE_END_TIME = 'T23:59:59Z';
export const timeZone = {
  AmericaNewYork: 'America/New_York',
} as const;

export const date = {
  /**
   * Preferred format to send to Back-end: YYYY-MM-DD
   */
  toISO: (date: DateType) => {
    return dayjs(date).format(DATE_ISO_FORMAT);
  },
  /**
   * Preferred format to display on Front-end: MM/DD/YYYY
   */
  toUSLocale: (date: DateType) => {
    return dayjs(date).format(DATE_US_LOCALE_FORMAT);
  },
  /**
   * Preferred format with time to display on Front-end: MM/DD/YYYY - h:mma
   */
  toUsLocaleWithTime: (date: DateType) => {
    return dayjs(date).format(DATE_WITH_TIME_US_LOCALE_FORMAT);
  },

  jsDateToUtcFormat: (date: Date, format?: string) => {
    const dateUtc = dayjs(date.toUTCString()).utc();
    return dateUtc.format(format || DATE_WITH_TIME_US_LOCALE_FORMAT);
  },

  jsDateToBackendFormat: (date: Date) => {
    const formattedDate = dayjs(date).format(DATE_ISO_FORMAT);
    const utcHrs = date.getUTCHours();
    const utcMins = date.getUTCMinutes();
    const utcSecs = date.getUTCSeconds();
    return `${formattedDate} ${utcHrs}:${utcMins}:${utcSecs}`;
  },
};
